import { Card, CardBody, Col, Form, Row } from "reactstrap";
import FormGroupCommon from "./Common/FormGroupCommon";
import SelectCommon from "./Common/SelectCommon";
import { CreditCards, CreditSelect } from "../../../Constant";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import CommonCardHeader from "../../../Common/CommonCardHeader";

const CreditCard = () => {
  return (
    <Col xl="8" className="box-col-80">
      <Card>
        <CommonCardHeader title={CreditCards} />
        <CardBody>
          <Row>
            <Col md="7" className="order-md-0 order-1">
              <Form className="theme-form mega-form">
                <FormGroupCommon type="text" placeholder="Card number" />
                <FormGroupCommon type="text" placeholder="First Name" />
                <FormGroupCommon type="date" />
                <FormGroupCommon type="text" placeholder="Name on card" />
                <SelectCommon data={CreditSelect} size={1} />
              </Form>
            </Col>
            <Col md="5" className="text-center">
              <Image className="img-fluid" src={dynamicImage("ecommerce/card.png")} alt="" />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CreditCard;
